import request from '@/request'
const part_url = 'train/web/universities/';

/**
 * 查询高校信息
 * @param {*} data
 * @returns
 */
function getList(data) {
    let url = part_url + "getList";
    return request.get(url, data)
}

/**
 * 学校类别
 * @returns
 */
function getSchoolCategory() {
    let url = part_url + "getSchoolCategory";
    return request.get(url)
}

/**
 *
 * @returns 查询院校特色
 */
function getSchoolFeature() {
    let url = part_url + "getSchoolFeature";
    return request.get(url)
}

/**
 * 查询高校信息
 * @param {查询高校信息} data
 * @returns
 */
function getCollegesMessage(data) {
    let url = part_url+"selectCollegesMessage";
    return request.get(url,data);
}

/**
 * 查询双选会详情
 * @param {查询双选会详情} data
 * @returns
 */
function getSchoolDoubleChannel(data) {
    let url = part_url+"getSchoolDoubleChannel";
    return request.get(url,data);
}

/**
 * 查询高校信息
 * @param {查询高校信息} data
 * @returns
 */
function getSchoolDictionaries(data) {
    let url = part_url+"getSchoolDictionaries";
    return request.get(url,data);
}

/**
 * 查询校园招聘首页轮播图
 * @returns
 */
function getSchoolCarouselImg() {
    let url = part_url + "getSchoolCarouselImg";
    return request.get(url);
}

function getSchoolEnterpriseImgList() {
    let url = part_url + "getSchoolEnterpriseImgList";
    return request.get(url);
}

export default {
    getList,
    getSchoolCategory,
    getSchoolFeature,
    getCollegesMessage,
    getSchoolDoubleChannel,
    getSchoolDictionaries,
    getSchoolCarouselImg,
    getSchoolEnterpriseImgList,
}



// WEBPACK FOOTER //
// ./src/api/universities.js